import moment from 'moment'
import _forEach from 'lodash/forEach'
import _set from 'lodash/set'
import _uniqWith from 'lodash/uniqWith'

import { isDateRangeValidator } from '../../../_common/core/validation'
import { FIELDS } from './utils'

const compareFn = (item1, item2) => item1.name === item2.name || item1.value === item2.value

const VALIDATION_RULES = {
  slug: value => {
    if (!value) return 'Slug is required'
    if (!/^[a-z0-9-]+$/.test(value)) return 'Slug can only contain lowercase letters, numbers and hyphens'
    return null
  },
  // approvedEmailTemplateId: value => (!value ? 'Approved email template is required' : null),
  // declinedEmailTemplateId: value => (!value ? 'Declined email template is required' : null),
  endDate: (value, values) => isDateRangeValidator()(moment(values.startDate), moment(value)),
}

export const validateForm = values => {
  const errors = {}

  Object.keys(VALIDATION_RULES).forEach(field => {
    const error = VALIDATION_RULES[field](values[field], values)
    if (error) {
      errors[field] = error
    }
  })

  _forEach(values.fields, (field, fieldIndex) => {
    if (
      field.type === FIELDS.RADIO.key ||
      field.type === FIELDS.SELECT.key ||
      field.type === FIELDS.SELECT_MULTI.key
    ) {
      if (!field.options?.length) {
        _set(errors, `fields.${fieldIndex}.options`, 'You must add at least one option.')
      }

      if (field.defaultValue && !field.options?.find(option => option.value === field.defaultValue)) {
        _set(errors, `fields.${fieldIndex}.defaultValue`, 'Invalid default value')
      }

      const uniqueOptions = _uniqWith(field.options, compareFn)
      if (field.options?.length !== uniqueOptions.length) {
        _set(errors, `fields.${fieldIndex}.options`, 'Options with same name or value are not allowed.')
      }
    }
  })

  return errors
}
